import { render, staticRenderFns } from "./Settlements.vue?vue&type=template&id=532ecc10&"
import script from "./Settlements.vue?vue&type=script&lang=js&"
export * from "./Settlements.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports